module.exports = __webpack_public_path__ + "img-addproject.18ea7e0f13187c3e919f14bb75f7d6a1.hashedasset.svg";